import React from 'react';
import '../styles/terms.css'; // Create a terms.css for styling

function TermsConditions() {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p>Please read these terms and conditions carefully before using our website.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using this website, you agree to be bound by these terms and conditions.</p>

      <h2>2. Use of Website</h2>
      <p>This website is intended for your personal and non-commercial use. You may not modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products, or services obtained from this website.</p>

      <h2>3. Intellectual Property</h2>
      <p>All content on this website, including text, graphics, logos, images, and software, is the property of Ronni Ceramics or its content suppliers and is protected by copyright laws.</p>

      <h2>4. Disclaimer</h2>
      <p>This website is provided on an "as is" and "as available" basis. Ronni Ceramics makes no representations or warranties of any kind, express or implied, as to the operation of this website or the information, content, materials, or products included on this website.</p>

      <h2>5. Limitation of Liability</h2>
      <p>Ronni Ceramics will not be liable for any damages of any kind arising from the use of this website, including, but not limited to direct, indirect, incidental, punitive, and consequential damages.</p>

      <h2>6. Governing Law</h2>
      <p>These terms and conditions are governed by and construed in accordance with the laws of Kosovo, and you submit to the exclusive jurisdiction of the courts located in Kosovo for the resolution of any disputes.</p>

      <h2>7. Changes to Terms</h2>
      <p>Ronni Ceramics reserves the right to make changes to these terms and conditions at any time. Your continued use of this website following any changes constitutes your acceptance of the new terms and conditions.</p>

      <h2>8. Contact Information</h2>
      <p>If you have any questions about these terms and conditions, please contact us at ronniceramics@gmail.com.</p>
    </div>
  );
}

export default TermsConditions;